import { Component, Input, OnInit } from '@angular/core';
import { Document, Enterprise, Insured, Share } from '../../models/models';
import { AuthService } from '../../services/auth.service';
import { DocumentService } from '../../services/document.service';
import { Errors } from '../../utils/errors';
import { ToastService } from '../../services/toast.service';
import { ModalService } from '../../services/modal.service';
import { AppComponent } from '../../app.component';
import { DataService } from '../../services/data.service';
import { ModalController } from '@ionic/angular';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-share',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss'],
})
export class ShareModalComponent implements OnInit {
  @Input() share: Share;
  selection: Document[] = [];
  logoFilename = environment.logoFilename || 'logo.svg';

  constructor(
    public authService: AuthService,
    public documentService: DocumentService,
    private toastService: ToastService,
    private modalService: ModalService,
    private dataService: DataService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.authService.user.subscribe((user) => {
      if (!user) {
        this.close();
      }
    });
  }

  close() {
    this.modalCtrl.dismiss();
  }

  downloadDocuments(documents: Document[]) {
    this.documentService
      .downloadDocuments(documents.map((e) => e.uuid))
      .then(async (res) => {})
      .catch(async (res) => {
        this.toastService.open({
          header: 'Oops !',
          message: Errors.getError(res),
          type: 'error',
        });
      });
  }

  toggleListItem(document: Document) {
    const index = this.selection.findIndex((d) => d.uuid === document.uuid);
    if (index !== -1) {
      this.selection.splice(index, 1);
    } else {
      this.selection.push(document);
    }
  }

  isSelected(document: Document) {
    return this.selection.findIndex((d) => d.uuid === document.uuid) !== -1;
  }

  async shareDocuments(documents: Document[] = null) {
    this.close();
    const data = {
      actionRequested: false,
      documentsSelection: documents || this.selection,
    };
    this.modalService.createShareDocumentModal(data);
    if (this.share?.source === 'insured') {
      data['selectedTarget'] = 'mutuelle';
      data['selectedMessage'] =
        "Veuillez trouver ci-joint les documents de l'assuré " +
        this.share?.insuredName +
        '.\nCordialement.';
      data['forceTarget'] = true;
    } else if (this.share?.source === 'mutuelle') {
      data['selectedTarget'] = 'insured';
      data['selectedMessage'] =
        'Veuillez trouver ci-joint une liste de documents.\nCordialement.';
      data['forceTarget'] = true;
    }
  }

  async addToLibrary(documents: Document[] = null) {
    this.documentService
      .addToLibrary(documents.map((e) => e.uuid))
      .then(async (res) => {
        const documents = await this.documentService.getDocuments(
          this.authService.user.value.accessType,
          AppComponent.enterprise.value?.id
        );
        this.dataService.documents.next(documents);
        this.toastService.open({
          header: 'Document ajouté !',
          message:
            'Le document a bien été ajouté. Vous pouvez le retrouver dans votre bibliothèque.',
          type: 'success',
        });
      })
      .catch(async (res) => {
        this.toastService.open({
          header: 'Oops !',
          message: Errors.getError(res),
          type: 'error',
        });
      });
  }

  reply() {
    const data = {
      actionRequested: false,
      forceTarget: true,
    };
    switch (this.share?.source) {
      case 'mutuelle':
        data['selectedTarget'] = 'mutuelle';
        break;
      case 'enterprise':
        data['enterprisesSelection'] = [
          new Enterprise({
            id: this.share?.enterpriseId,
            name: this.share?.enterpriseName,
          }),
        ];
        data['selectedTarget'] = 'enterprise';
        break;
      case 'insured':
        data['insured'] = new Insured({
          id: this.share?.insuredId,
          fullname: this.share?.insuredName,
        });
        data['selectedTarget'] = 'insured';
        break;
    }
    this.close();
    this.modalService.createShareDocumentModal(data);
  }
}
